import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "cdes-page" }
const _hoisted_2 = ["for", "id"]
const _hoisted_3 = ["id", "aria-labelledby"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 3 }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["for", "id"]
const _hoisted_15 = ["id", "aria-labelledby"]
const _hoisted_16 = ["for", "id"]
const _hoisted_17 = ["id", "aria-labelledby"]
const _hoisted_18 = { class: "col-auto" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-show-object-planner" }, null, -1)
const _hoisted_20 = {
  key: 1,
  class: "btn btn-outline-secondary disabled",
  "aria-disabled": "true"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-show-object-planner" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "alert alert-danger fw-bold ms-4"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["name", "id", "disabled", "value"]
const _hoisted_26 = ["for"]
const _hoisted_27 = {
  key: 0,
  class: "badge bg-primary"
}
const _hoisted_28 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_29 = ["for", "id"]
const _hoisted_30 = ["disabled", "id"]
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = { class: "row g-4" }
const _hoisted_34 = { class: "col-auto" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "uploadWithPreviewLogList" }
const _hoisted_39 = {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadedOrPlaceholder = _resolveComponent("LoadedOrPlaceholder")!
  const _component_FormGridMember = _resolveComponent("FormGridMember")!
  const _component_FormGridColumn = _resolveComponent("FormGridColumn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UploadWithPreview = _resolveComponent("UploadWithPreview")!
  const _component_EditDocumentReferences = _resolveComponent("EditDocumentReferences")!
  const _component_EditStatements = _resolveComponent("EditStatements")!
  const _component_EditCommentListWidget = _resolveComponent("EditCommentListWidget")!
  const _component_ShowReviewMatrix = _resolveComponent("ShowReviewMatrix")!
  const _component_FormGrid = _resolveComponent("FormGrid")!
  const _component_Transform = _resolveComponent("Transform")!
  const _component_PasswordDialog = _resolveComponent("PasswordDialog")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Transform, { transformer: _ctx.formTransformer }, {
      default: _withCtx(() => [
        _createVNode(_component_FormGrid, {
          labelWidth: 9,
          class: "placeholder-glow needs-validation"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('review.upload.page.heading')), 1),
            _createVNode(_component_FormGridColumn, {
              size: 4,
              class: _normalizeClass(["mt-0", { 'was-validated': _ctx.wasValidated }])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FormGridMember, null, {
                  label: _withCtx(({ class: clazz, controlId, id }) => [
                    _createElementVNode("label", {
                      class: _normalizeClass(`${clazz} col-form-label`),
                      for: controlId,
                      id: id
                    }, _toDisplayString(_ctx.$t('general.planNumber')), 11, _hoisted_2)
                  ]),
                  control: _withCtx(({ id, labelId }) => [
                    _createElementVNode("div", {
                      class: "form-control-plaintext",
                      id: id,
                      "aria-labelledby": labelId
                    }, [
                      (!this.uploadInfo.versionPartAEditable && !this.uploadInfo.versionPartBEditable)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_LoadedOrPlaceholder, {
                              value: this.uploadInfo
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(this.uploadInfo.planNumber), 1)
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]))
                        : _createCommentVNode("", true),
                      (this.uploadInfo.versionPartAEditable || this.uploadInfo.versionPartBEditable)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_LoadedOrPlaceholder, {
                              value: this.uploadInfo,
                              class: "me-2 uploadInfoVersionLastSeperator"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(this.uploadInfo.documentNumber + (this.uploadInfo.versionLastSeperator?this.uploadInfo.versionLastSeperator:'')), 1)
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            (this.uploadInfo.versionPartANumeric)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                  _withDirectives(_createElementVNode("input", {
                                    name: "partA",
                                    type: "number",
                                    min: "0",
                                    max: "99",
                                    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkValueA && _ctx.checkValueA(...args))),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.uploadInfo.versionPartA) = $event)),
                                    class: "me-2 versionPart",
                                    disabled: !this.uploadInfo.versionPartAEditable
                                  }, null, 40, _hoisted_7), [
                                    [_vModelText, this.uploadInfo.versionPartA]
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                  _withDirectives(_createElementVNode("input", {
                                    name: "partA",
                                    type: "text",
                                    maxlength: "2",
                                    onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkValueA && _ctx.checkValueA(...args))),
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.uploadInfo.versionPartA) = $event)),
                                    class: "me-2 versionPart",
                                    disabled: !this.uploadInfo.versionPartAEditable
                                  }, null, 40, _hoisted_9), [
                                    [_vModelText, this.uploadInfo.versionPartA]
                                  ])
                                ])),
                            (this.uploadInfo.versionPartBNumeric)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                  _withDirectives(_createElementVNode("input", {
                                    name: "partB",
                                    type: "number",
                                    min: "0",
                                    max: "99",
                                    onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkValueB && _ctx.checkValueB(...args))),
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.uploadInfo.versionPartB) = $event)),
                                    class: "me-2 versionPart",
                                    disabled: !this.uploadInfo.versionPartBEditable
                                  }, null, 40, _hoisted_11), [
                                    [_vModelText, this.uploadInfo.versionPartB]
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                  _withDirectives(_createElementVNode("input", {
                                    name: "partB",
                                    type: "text",
                                    maxlength: "2",
                                    onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.checkValueB && _ctx.checkValueB(...args))),
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.uploadInfo.versionPartB) = $event)),
                                    class: "me-2 versionPart",
                                    disabled: !this.uploadInfo.versionPartBEditable
                                  }, null, 40, _hoisted_13), [
                                    [_vModelText, this.uploadInfo.versionPartB]
                                  ])
                                ]))
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_3)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_FormGridColumn, {
              size: 4,
              class: _normalizeClass([{ 'was-validated': _ctx.wasValidated }, "mt-lg-0"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FormGridMember, null, {
                  label: _withCtx(({ class: clazz, controlId, id }) => [
                    _createElementVNode("label", {
                      class: _normalizeClass(`${clazz} col-form-label`),
                      for: controlId,
                      id: id
                    }, _toDisplayString(_ctx.$t('review.upload.page.title')), 11, _hoisted_14)
                  ]),
                  control: _withCtx(({ id, labelId }) => [
                    _createElementVNode("div", {
                      class: "form-control-plaintext",
                      id: id,
                      "aria-labelledby": labelId
                    }, [
                      _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.uploadInfo }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$s(_ctx.uploadInfo.content)), 1)
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ], 8, _hoisted_15)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_FormGridColumn, {
              size: 4,
              class: _normalizeClass([{ 'was-validated': _ctx.wasValidated }, "mt-lg-0"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FormGridMember, null, {
                  label: _withCtx(({ class: clazz, controlId, id }) => [
                    _createElementVNode("label", {
                      class: _normalizeClass(`${clazz} col-form-label`),
                      for: controlId,
                      id: id
                    }, _toDisplayString(_ctx.$t('review.upload.page.scale')), 11, _hoisted_16)
                  ]),
                  control: _withCtx(({ id, labelId }) => [
                    _createElementVNode("div", {
                      class: "form-control-plaintext",
                      id: id,
                      "aria-labelledby": labelId
                    }, [
                      _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.uploadInfo }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.uploadInfo.scale), 1)
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ], 8, _hoisted_17)
                  ]),
                  additional: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      (_ctx.uploadInfo !== _ctx.loadingPlaceholder)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            disabled: this.disabled,
                            class: "btn btn-outline-secondary",
                            title: _ctx.$t('general.objectPlanner'),
                            to: { name : 'objectPlannerReleaseShowDocument', params : { documentId : this.documentId } }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          }, 8, ["disabled", "title", "to"]))
                        : (_openBlock(), _createElementBlock("a", _hoisted_20, _hoisted_22))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_FormGridMember, {
              fieldset: "",
              class: _normalizeClass({ 'was-validated': _ctx.wasValidated })
            }, {
              label: _withCtx(({ class: clazz }) => [
                _createElementVNode("legend", {
                  class: _normalizeClass(`${clazz} col-form-label`)
                }, _toDisplayString(_ctx.$t('review.upload.page.destination')), 3)
              ]),
              control: _withCtx(() => [
                (_ctx.renderedDestinations.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t('review.upload.page.noDestinationFound')), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderedDestinations, (destination, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: destination.id,
                          class: "form-check"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            name: _ctx.$id('dest'),
                            id: _ctx.$id('dest'+destination.id),
                            disabled: this.disabled || destination === _ctx.loadingPlaceholder || this.fileWasUploaded,
                            value: destination === _ctx.loadingPlaceholder ? null : destination,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedDestination) = $event)),
                            required: ""
                          }, null, 8, _hoisted_25), [
                            [_vModelRadio, _ctx.selectedDestination]
                          ]),
                          _createElementVNode("label", {
                            class: "form-check-label",
                            type: "radio",
                            for: _ctx.$id('dest'+destination.id)
                          }, [
                            _createVNode(_component_LoadedOrPlaceholder, { value: destination }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$s(destination.name)) + " ", 1),
                                (destination.isReupload)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('review.upload.page.reuploadBadge')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          ], 8, _hoisted_26),
                          (index === (_ctx.renderedDestinations.length - 1))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t('review.upload.page.noDestination')), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
              ]),
              _: 1
            }, 8, ["class"]),
            (this.destinationId != null)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass({ 'was-validated': _ctx.wasValidated })
                }, [
                  _createVNode(_component_UploadWithPreview, {
                    disabled: this.disabled,
                    ref: "uploadWithPreview",
                    planNumber: _ctx.mapLoading(a => a.planNumber, _ctx.uploadInfo),
                    unreleasedDocumentId: _ctx.documentId,
                    taskId: _ctx.taskId,
                    uploadInfo: _ctx.uploadInfo,
                    destinationId: _ctx.reviewCycleCellId,
                    "onUpdate:temporaryDocumentVersionId": _cache[9] || (_cache[9] = ($event: any) => (this.temporaryDocumentVersionId = $event)),
                    "onUpdate:notFoundResolution": _cache[10] || (_cache[10] = ($event: any) => (this.notFoundResolution = $event)),
                    "onUpdate:labelStatus": _cache[11] || (_cache[11] = ($event: any) => (this.labelStatus = $event)),
                    onFileUploaded: _cache[12] || (_cache[12] = ($event: any) => (this.processFileUploaded())),
                    "onUpdate:selectedRotation": _cache[13] || (_cache[13] = ($event: any) => (this.selectedRotation = $event))
                  }, null, 8, ["disabled", "planNumber", "unreleasedDocumentId", "taskId", "uploadInfo", "destinationId"])
                ], 2))
              : _createCommentVNode("", true),
            (this.destinationId != null)
              ? (_openBlock(), _createBlock(_component_FormGridMember, { key: 1 }, {
                  label: _withCtx(({ class: clazz, controlId, id }) => [
                    _createElementVNode("label", {
                      class: _normalizeClass(`${clazz} col-form-label`),
                      for: controlId,
                      id: id
                    }, _toDisplayString(_ctx.$t('review.upload.page.comment')), 11, _hoisted_29)
                  ]),
                  control: _withCtx(({ id }) => [
                    _withDirectives(_createElementVNode("textarea", {
                      disabled: this.disabled,
                      class: "form-control",
                      id: id,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.comment) = $event))
                    }, "\n            ", 8, _hoisted_30), [
                      [_vModelText, _ctx.comment]
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.temporaryDocumentVersionId != null && this.destinationId != null)
              ? (_openBlock(), _createElementBlock("section", _hoisted_31, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('general.documentReferences')), 1),
                  _createVNode(_component_EditDocumentReferences, {
                    disabled: this.disabled,
                    wasValidated: _ctx.wasValidated,
                    temporaryDocumentVersionId: _ctx.temporaryDocumentVersionId,
                    persistentDocumentReferences: this.uploadInfo != _ctx.loadingPlaceholder 
                                                               ? this.uploadInfo.documentReferences : [],
                    onDoDelete: this.registerDocumentReferenceIdToDelete
                  }, null, 8, ["disabled", "wasValidated", "temporaryDocumentVersionId", "persistentDocumentReferences", "onDoDelete"])
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("section", {
              class: _normalizeClass({ 'was-validated': _ctx.wasValidated })
            }, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('review.upload.page.statements')), 1),
              _createVNode(_component_EditStatements, {
                disabled: this.disabled,
                taskId: _ctx.taskId,
                destinationId: _ctx.destinationId,
                destinationType: _ctx.destinationType,
                modelValue: _ctx.statements,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.statements) = $event)),
                "onUpdate:hidden": _cache[16] || (_cache[16] = ($event: any) => (_ctx.statementsHidden = $event))
              }, null, 8, ["disabled", "taskId", "destinationId", "destinationType", "modelValue"])
            ], 2), [
              [_vShow, !_ctx.statementsHidden && this.destinationId != null]
            ]),
            _withDirectives(_createElementVNode("section", {
              class: _normalizeClass({ 'was-validated': _ctx.wasValidated })
            }, [
              _createVNode(_component_EditCommentListWidget, {
                disabled: this.disabled,
                taskId: _ctx.taskId,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.comments = $event))
              }, null, 8, ["disabled", "taskId"])
            ], 2), [
              [_vShow, this.documentVersionId != null && this.destinationId != null]
            ]),
            (_ctx.reviewCycleCellId != null && this.destinationId != null)
              ? (_openBlock(), _createElementBlock("section", {
                  key: 3,
                  class: _normalizeClass({ 'was-validated': _ctx.wasValidated })
                }, [
                  _createVNode(_component_ShowReviewMatrix, {
                    disabled: this.disabled,
                    ref: "showReviewMatrix",
                    documentId: _ctx.documentId,
                    documentVersionId: this.documentVersionId,
                    reviewCycleCellId: _ctx.reviewCycleCellId,
                    "onUpdate:hidden": _cache[18] || (_cache[18] = ($event: any) => (_ctx.reviewMatrixHidden = $event))
                  }, null, 8, ["disabled", "documentId", "documentVersionId", "reviewCycleCellId"])
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  (this.documentVersionId != null)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-secondary me-2",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.save())),
                        disabled: this.disabled || this.destinationId == null
                      }, _toDisplayString(_ctx.$t('general.save')), 9, _hoisted_35))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: this.disabled || this.destinationId == null || !this.fileWasUploaded || this.labelNotFoundOrUnknown,
                    class: "btn btn-primary me-2"
                  }, _toDisplayString(_ctx.$t('general.sign')), 9, _hoisted_36),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.abort())),
                    disabled: this.disabled
                  }, _toDisplayString(_ctx.$t('general.cancel')), 9, _hoisted_37)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["transformer"]),
    _createVNode(_component_PasswordDialog, {
      ref: "passwordDialog",
      submitLabel: _ctx.$t('general.sign'),
      title: _ctx.$t('review.upload.preview.passwordTitle')
    }, null, 8, ["submitLabel", "title"]),
    _createVNode(_component_Dialog, {
      lazy: "",
      title: _ctx.$t('review.upload.logTitle'),
      ref: "logDialog",
      extraClasses: "modal-xl modal-fullscreen-xl-down"
    }, {
      default: _withCtx(({ data }) => [
        _createElementVNode("ol", _hoisted_38, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data, (content, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(content), 1))
          }), 128))
        ])
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("button", _hoisted_39, _toDisplayString(_ctx.$t('general.close')), 1)
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}